import React from 'react';
import { Link } from "react-router-dom";

import Testimonials from "../../components/testimonials/testimonials";
import NextGig from "../../components/next-gig/next-gig";
import FeaturedSong from "../../components/featured-song/featured-song";

// images
import splash from "../../assets/images/Salty-Trio.jpg";
import splashMed from "../../assets/images/Salty-Trio-med.jpg";
import splashSmall from "../../assets/images/Salty-Trio-small.jpg";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullhorn } from "@fortawesome/free-solid-svg-icons";

import "./home.scss";

library.add(faBullhorn);

function Home() {
  return (
    <div className="home-page">
      <picture>
        <source
          srcSet={splash}
          media="(min-width: 1200px)"
        />
        <source
          srcSet={splashMed}
          media="(min-width: 800px)"
        />
        <source
          srcSet={splashSmall}
          media="{min-width: 400px)"
        />
        <img
          src={splashMed}
          className="splash-image"
          alt="Salty Trio"
        />
      </picture>
      <div className="page-content gutter">
        <h1>We are Salty</h1>
        <div className="row title-row">
          <FontAwesomeIcon className="page-icon" icon={faBullhorn} />
          <div className="page-copy">
            <p>
              We are Salty, a Toronto-based power trio who cover the hits you don&apos;t hear enough.
              Our explosive and eclectic music spans rock, alternative, grunge, metal and pop from yesterday and today.
            </p>
            <p>
              Our high-energy performances feature electrifying guitar riffs, driving bass lines, and thundering drum beats that are sure to get you moving.
            </p>
            <p>
              We avoid the cliché (No Mustang Sally or Brown Eyed Girl here!) and our performances exhilarate audiences at pubs, bars, corporate gatherings, festivals and private celebrations.
              Join Salty for an evening of unforgettable entertainment!
            </p>
            <p>
              Check out the music we play&nbsp;<Link reloadDocument to='/music'>here</Link>.&nbsp;
            </p>
            <p>#wearesalty #youaresalty #weareallsalty</p>
            <div className="quote">
              "If music be the food of love, play on; Give me excess of it"
            </div>
            <span>- William Shakespeare, "Twelfth Night"</span>
          </div>
        </div>
        <div className="row feature">
          <Testimonials />
          <NextGig />
          <FeaturedSong />
        </div>
      </div>
    </div>
  );
}

export default Home;